import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./plugins/router";
import {store} from "./plugins/store";

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
    const publicPages = ["/login", "/"];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem("jwt");
    if (authRequired && !loggedIn) {
      return next("/");
    }
    return next();
});

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
